import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, ImageWrapper, TextEmptyState } from './styles';

const EmptyStateScore = ({ image, withSpacing, height, top, callback }) => {
  const { t } = useTranslation();

  return (
    <Container height={height}>
      {image && <ImageWrapper image={image} data-panel='panel-estadisticas-emptyState-image' />}
      <TextEmptyState position={image} top={top} data-panel='panel-estadisticas-emptyState-text'>
        {withSpacing && <div className='spacing' />}
        <p>{t('panel.estadisticas.emptyState')}</p>
        <p>
          {t('panel.estadisticas.emptyState.pre')}
          <button className='CTA' onClick={callback} type='button' data-panel='panel-estadisticas-emptyState-CTA'>
            {t('panel.estadisticas.emptyState.cta')}
          </button>
          {t('panel.estadisticas.emptyState.post')}
        </p>
      </TextEmptyState>
    </Container>
  );
};

export default EmptyStateScore;
